import { render, staticRenderFns } from "./PayableReceivableMark.vue?vue&type=template&id=b2c2e146&scoped=true&"
import script from "./PayableReceivableMark.vue?vue&type=script&lang=js&"
export * from "./PayableReceivableMark.vue?vue&type=script&lang=js&"
import style0 from "./PayableReceivableMark.vue?vue&type=style&index=0&id=b2c2e146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c2e146",
  null
  
)

export default component.exports